import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { useSubmitMenuItem } from '../../../../hooks/useSubmitMenuItem';
import s from './SubmitMenuItem.scss';
const SubmitMenuItem = ({ className, type, modalType, modalOptions, label, link, target, verificationAction })=>{
    const { t } = useTranslation();
    const { onClick, href, biData } = useSubmitMenuItem({
        modalType,
        link,
        verificationAction,
        type,
        modalOptions
    });
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: classnames(s['submit-menu-item'], className),
        href: href,
        target: target,
        tabIndex: 0,
        onClick: onClick,
        biData: biData,
        isFakeButton: !onClick
    }, t(label));
};
SubmitMenuItem.displayName = 'SubmitMenuItem';
export default SubmitMenuItem;

//# sourceMappingURL=SubmitMenuItem.js.map